import purple from '@mui/material/colors/purple';

const styles = theme => ({
    listItemRoot: {
        backgroundColor: theme.palette.background.paper,
        border: 'solid 1px transparent',
        borderBottom: 'solid 1px gainsboro',
    },
    imminent: {
        fontWeight: 600
    },
    complete: {
        fontWeight: 600
    },
    imminentIcon: {
        float: 'left',        
    },
    caption: {
        fontSize: 14
    },
    selected: {
        borderColor: theme.palette.secondary.main,
        borderStyle: 'solid',
        borderWidth: 1
    },
    emptyMessage: {
        fontSize: 42,
        marginTop: 100,
        marginBottom: 100,
        '@media (max-width: 360px)': {
            marginTop: 50,
            marginBottom: 0,
        }
    },
    expiryPanel: {
        backgroundColor: theme.palette.background.paper,
        borderBottom: `solid 1px ${theme.palette.common.border}`,
        margin: 0,
        width: '100%'
    },
    disabled: {
        opacity: 0.7
    },
    expiryIcon: {
        color: theme.palette.text.disabled,
        margin: theme.spacing(1)
    },
    expiryActive: {
        color: purple[500],
    },
    expiryDateLabel: {
        marginLeft: theme.spacing(1),
    }
});

export default styles;